import { h, Component } from 'preact'
import _ from './styles.sass'
import Fuse from 'fuse.js'
import { clone } from 'lodash'

import Search from '@shared/components/Search'
import colorScale from '@root/lib/colorScale'
import { latestValue } from '@root/lib/valuesFromStation'

export default class StationsDropdown extends Component {
  state = {
    suggestions: null
  }

  searchOptions = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ['properties.name', 'properties.federalstate']
  }

  handleInput = (value) => {
    const stations = clone(this.props.stations).sort((a, b) => {
      return a.properties.name.localeCompare(b.properties.name)
    })
    const fuse = new Fuse(stations, this.searchOptions)

    const results = value === '' ? stations : fuse.search(value)

    const suggestions = results
      .map(result => {
        const value = latestValue(result)
        return {
          value: result,
          label: <p class={_.result}>
            <i style={{ backgroundColor: colorScale(value).hex() }} />
            { result.properties.name }
          </p>
        }
      })
    this.setState({ suggestions })
  }

  handleResultSelect = (result) => {
    const stations = this.props.stations
    const index = stations.findIndex(station => station.properties.id === result.properties.id)
    this.context.actions.selectMarker({ byIndex: index })
  }

  handleReset = () => {
    this.setState({ suggestions: null })
  }

  render () {
    const { class: className } = this.props
    const { suggestions } = this.state

    const searchProps = {
      asDropdown: true,
      onInput: this.handleInput,
      onResult: this.handleResultSelect,
      onReset: this.handleReset,
      placeholder: 'Station auswählen',
      nothingFoundText: 'keine Station gefunden',
      suggestions: suggestions
    }

    return <Search class={className} {...searchProps} />
  }
}
